export enum GuessedConnectionAutocompleteConstantOptions {
  MARK_AS_NA = "--Do not import file",
  LEAVE_UNMATCHED = "--Leave file uncategorized",
}
